export const klok15 = require('./Klok.mp3');
export const douche15 = require('./Douche.mp3');
export const wasmachine15 = require('./Wasmachine.mp3');
export const computer_ventilator15 = require('./Computer_ventilator.mp3');
export const licht_ruis15 = require('./Licht_ruis.mp3');
export const afzuigkap15 = require('./Afzuigkap.mp3');
export const airco15 = require('./Airco.mp3');
export const fornuis15 = require('./Fornuis.mp3');
export const friezer15 =require('./Friezer.mp3');